import { petcoBlue } from '@common/_assets/color-constants.js';
import React, { CSSProperties } from 'react';
import PulseLoader from 'react-spinners/PulseLoader';
export interface IAppSpinnerProps {
  spinnerCSSOverride?: CSSProperties;
}

export const AppSpinner = ({ spinnerCSSOverride }: IAppSpinnerProps) => {
  const spinnerDefault: CSSProperties = {
    margin: '350px auto 0',
    zIndex: 1050,
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    width: '60px',
  };

  return (
    <>
      <PulseLoader
        cssOverride={spinnerCSSOverride ?? spinnerDefault}
        color={petcoBlue}
      >
        <span className="visually-hidden">Loading...</span>
      </PulseLoader>
    </>
  );
};
